import Axios from "axios";

const base_url = "cp/shipments-returned-to-customers";

export default {
    /**
     * Display a listing of the shipments-returned-to-customers.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(`${base_url}?page=${page}`, { params });
    },

    /**
     * Store a new shipments-returned-to-customers in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Show data for a given Adjustment.
     *
     * @param {int} id
     * @returns {Promise}
     */
    getById(id) {
        return Axios.get(`${base_url}/${id}`);
    },

    /**
     * Update the given shipments-returned-to-customers in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(`${base_url}/${data.id}`, data);
    }

    /**
     * Remove the specified shipments-returned-to-customers from server.
     *
     * @param {int} id
     * @returns {Promise}
     */
    //delete(id) {
    //    return Axios.delete(`${base_url}/${id}`);
    //}
};
